<template>
    <div class="honorList" v-show="isShow">
        <div style="width: 0px;height: 40px;"></div>
        <div style="display: flex;justify-content: space-evenly;">
          <transition name="fade">
                <div class="leftList" v-show="listShow && leftList.length > 0">
                    <div v-for="(item) in leftList" :key="item.id" class="list-item"
                        :class="{ active: selectedCoursewareId === item.id }" @click="activeCourseware(item)">
                        <el-tooltip :content="item.courseware_name || item.name" effect="dark" placement="top" :open-delay="0">
                            <div class="tooltip_div">
                                <img src="@/assets/img/courseExplanation/other.jpg" alt="课件">
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="rightList" v-show="listShow && rightList.length > 0">
                    <div v-for="(item) in rightList" :key="item.id" class="list-item"
                        :class="{ active: selectedVideoId === item.id }" @click="activevideo(item)">
                        <el-tooltip :content="item.courseware_name || item.name" effect="dark" placement="top" :open-delay="0">
                            <div class="tooltip_div">
                                <img v-if="item.file_type == 'mp4'" src="@/assets/img/courseExplanation/video.jpg"
                                    alt="视频">
                                <img v-if="item.file_type == 'mp3'" src="@/assets/img/courseExplanation/audio.jpg"
                                    alt="音频">
                                <img v-if="item.file_type == 'wav'" src="@/assets/img/courseExplanation/audio.jpg"
                                    alt="音频">
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: "HonorList",
    props: ['leftList', 'rightList'],
    data() {
        return {
            selectedCoursewareId: null, // 选中的课件ID
            selectedVideoId: null, // 选中的视频ID
            listShow: true,
        }
    },
    watch:{
        leftList(val){            
        },
        rightList(val){
        }
    },
    computed: {
        isShow() {
            // 引用路由路径作为响应式依赖: localStorage 本身非响应式, 路由切换时重算, 否则首次求值后永久缓存旧值
            void this.$route.path
            try {
                return JSON.parse(localStorage.getItem('courseButton')) === true
            } catch (e) {
                return false
            }
        }
    },
    methods: {

        activeCourseware(item) {
            if (this.selectedCoursewareId == item.id) {
                this.selectedCoursewareId = null
            } else {
         
                this.selectedCoursewareId = item.id; // 设置选中的课件ID
            }
            this.$emit('toggleOffice', item)
            this.$emit('clickOffice', item)

        },
 
        activevideo(item) {
            if (this.selectedVideoId == item.id) {
                this.selectedVideoId = null
                this.$emit('pause')
            } else {
                this.selectedVideoId = item.id; // 设置选中的视频ID
            }
            this.$emit('toggleVideo', item)
        }
    },
}
</script>

<style scoped lang="scss">
.honorList {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
}

.leftList,
.rightList {
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    max-width: 450px;
    overflow-x: auto;
    white-space: nowrap;
}

.leftList {
    right: calc(100% - 10px);
}

.rightList {
    left: calc(100% + 10px);
}

.list-item {
    color: #000;
    cursor: pointer;
    user-select: none;
    background-size: 100% 100%;
    border-radius: 50%;
    overflow: hidden;
    width: 50px;
    height: 50px;
    position: relative;
    z-index: 10001;
    /* 禁止文本被选中 */
}

.tooltip_div {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0px;
    left: 0px;
}

.list-item.active {
    background: rgba(0, 0, 0, 0.8);
    /* 为选中的项添加样式 */
}

.list-item:last-child {
    margin-right: 0;
}


.coursewareBtn {
    width: 50px;
    height: 50px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: #000;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    margin: 20px;
    cursor: pointer;
    z-index: 1;
    border-radius: 50%;
    overflow: hidden;
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在Vue3中被替代 */
    {
    opacity: 0;
}

.coursewareBtn:active {
    transform: scale(0.9);
}

img {
    width: 100%;
    height: 100%;
}

/* 提高 tooltip 的 z-index，确保在视频之上 */
::v-deep .el-tooltip__popper {
    z-index: 10002 !important;
}
</style>

<style lang="scss">
.el-tooltip__popper {
    z-index: 10002 !important;
}
</style>
